import cheatSheets from './cheatSheets';
import Requester from './huddle-request';
import formula from './formula';
import lookups from './lookups';
import players from './players';
import stats from './stats';
import rankings from './rankings';
import tracking from './tracking';
import user from './user';
import projections from './projections';
import teams from './teams';
import subscribe from './subscribe';

const api = ({ token }) => {
  const request = Requester({ token });

  return {
    cheatSheets: cheatSheets({ request }),
    formula: formula({ request }),
    lookups: lookups({ request }),
    players: players({ request }),
    teams: teams({ request }),
    stats: stats({ request }),
    rankings: rankings({ request }),
    tracking: tracking({ request }),
    user: user({ request }),
    projections: projections({ request }),
    subscribe: subscribe({ request }),
  };
};

export default api;



// WEBPACK FOOTER //
// ./src/lib/api/index.js